import { useState } from 'react';
import { useToast } from '@crisellevaldez/speculo-ui';
import { addCRMClient } from '../../../api/crm';

interface AddCRMIntegrationParams {
  organizationId: string;
  email: string;
  password: string;
}

export const useAddCRMIntegration = () => {
  const [isPending, setIsPending] = useState(false);
  const { showToast } = useToast();

  /**
   * Add a CRM integration for an organization
   * @param params The parameters for adding a CRM integration
   * @returns A promise that resolves to true if successful
   */
  const addCRMIntegration = async ({
    organizationId,
    email,
    password,
  }: AddCRMIntegrationParams): Promise<boolean> => {
    if (!organizationId || !email || !password) {
      showToast({
        message: 'Organization ID, email, and password are required',
        variant: 'error',
      });
      return false;
    }

    setIsPending(true);
    try {
      // Call the API function to add a CRM client
      const success = await addCRMClient(organizationId, email, password);
      return success;
    } catch (error) {
      console.error('Error adding CRM integration:', error);
      showToast({
        message: 'Failed to add CRM integration',
        variant: 'error',
      });
      return false;
    } finally {
      setIsPending(false);
    }
  };

  return {
    addCRMIntegration,
    isPending,
  };
};
